// import NotFoundPage from "pages/not-found-page";
import { Navigate, Outlet } from "react-router-dom";


function PrivateRoute({ component: Component, ...rest }: any) {

    return localStorage.getItem("isLogged") === "true" ? <Outlet /> : <Navigate to={localStorage.getItem('clientName') === 'Amspec_clone' ? '/login?env=AmSpec' : "/login"} />;

}

export default PrivateRoute